<template>
  <div class="">
    <ed-select
      field-label='Supplier'
      :placeholder='supplierComboPlaceholder'
      :options='suppliers'
      v-model='supplier'
      required
      :customLabel='getLabel'
      @open='fetchSuppliersOnOpen'
      @search="fetchSuppliers"
      server-search
      @close='restoreSuppliers'
      @select="selectedSupplier($event)"
      :openEndpoint='api.$.invoice.suppliers'
      helptipHeader=''
      track-by="Key"
      :disabled="disableSupplier(supplier) || isP2PInvoice"
      :error='model.Errors.SupplierMissing'
      :helptip-body='model.Errors.SupplierMissing && "Please select a Supplier." || ""'
      name='suppliers'
    >
      <template
        slot='option'
        slot-scope='props'>
        <ed-select-options thumbnails>
          <div slot='row1' class="option-combo-img">
            <img slot='image' :src='props.option.Value.Logo' width='48' />
          </div>
          <div slot='row2' class="no-wrap">
             <span class="option-strong"> <strong >{{ he.decode(props.option.Value.CompanyName) }} </strong> </span>
             <em class="option-em">({{props.option.Value.Vci}})</em>
            <br />
            <span v-if='props.option.Value.SupplierName' class="option-bold"> {{ he.decode(props.option.Value.SupplierName) }}</span>
            <span v-if='props.option.Value.SupplierRequestedName'>
              <br/>
              <i>{{ props.option.Value.SupplierRequestedName }}</i>
            </span>
            <span v-if='props.option.Value.CountryName' class="address-wrap">
              <br/>
              <span class="fas fa-map-marker-alt contact-icon"></span> &nbsp;{{ props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName }}
                <span v-if = 'isEoadmin'> {{ props.option.Value.SupplierZIP}} </span>
            </span>
            <span v-if='props.option.Value.BusinessType'>
              <br/>
              <span class="fas fa-briefcase contact-icon"></span> &nbsp;{{ props.option.Value.BusinessType }}
            </span>
            <span v-if='props.option.Value.SupplierEmail'>
              <br/>
              <span class="fas fa-envelope contact-icon">
                </span> &nbsp;{{ props.option.Value.SupplierEmail }}
            </span>
            <span v-if='props.option.Value.VatGstId && isEoadmin'>
              <br/>
              <span class="fas fa-file-alt contact-icon">
              </span> &nbsp;{{ props.option.Value.VatGstId}}
              <br/>
            </span>
            <br />
            <span v-if='props.option.Value.IsEvedPay' class="label supplier-evedpay">EvedPay Ready</span>
            <span v-if='props.option.Value.VendorType' class="label" :class="[`supplier-type-${props.option.Value.VendorType}`]" >{{ props.option.Value.VendorType }} Supplier</span>
            <span v-if='props.option.Value.Currencies'>
              <br/>
              Currencies accepted: {{ props.option.Value.Currencies }}
            </span>
          </div>
        </ed-select-options>
      </template>
    </ed-select>

    <div v-if="supplier">
      <br />
      <ed-card
        class="supplier-details"
        :removable="!isP2PInvoice"
        @removecard="removeSupplier"
        name='supplier_card'>
        <div slot="body" >
          <div class="supplier-img">
            <img slot='image' :src='supplier.Value.Logo' width='95'/>
          </div>
          <div class="no-wrap supplier-txt">
            <span v-if='supplier'>
              <strong class="supplier-strong">{{supplier.Value.CompanyName}} </strong>
              <em class="supplier-em">{{ supplier.Value.Vci ? '(' + supplier.Value.Vci + ')' : '' }}</em>
              <br />
            </span>
            <b>
              <span v-if='supplier && supplier.Value.SupplierName' class="supplier-strong"> {{ supplier.Value.SupplierName }}
                <br/>
              </span>
            </b>
            <span v-if='supplier && supplier.Value.CountryName' class="address-wrap">
              <span class="fas fa-map-marker-alt contact-icon"></span> &nbsp;{{ supplier.Value.City + (supplier.Value.State != '' && supplier.Value.State != null ? ' ' + supplier.Value.State : (supplier.Value.Region != '' && supplier.Value.Region != null ? ' ' + supplier.Value.Region : '')) + ' ' + supplier.Value.CountryName }}
              <span v-if = 'isEoadmin'> {{ supplier.Value.SupplierZIP}} </span>
              <br/>
            </span>
            <span v-if='supplier && supplier.Value.BusinessType'>
              <span class="fas fa-briefcase contact-icon"></span> &nbsp;{{ supplier.Value.BusinessType }}
              <br/>
            </span>
            <span v-if='supplier && supplier.Value.SupplierEmail'>
              <span class="fas fa-envelope contact-icon"></span> &nbsp;{{ supplier.Value.SupplierEmail }}
              <br/>
            </span>
            <span v-if='supplier && bankAccount && isEoadmin'>
              <span class="fas fa-university contact-icon">
              </span> &nbsp;{{ bankAccount }}
              <span class="bank-account"> {{ currencyCode }} </span>
              <br>
            </span>
            <span v-if='supplier && supplier.Value.VatGstId && isEoadmin'>
              <span class="fas fa-file-alt contact-icon"></span> &nbsp;{{ supplier.Value.VatGstId }}
              <br/>
            </span>
            <div>
              <span v-if="displayEvedPayStatus" class="label" :class="[`supplier-${label(evedPayStatus)}`]">{{ evedPayStatus }}</span>
              <span v-if="supplier && supplier.Value.VendorType" class="label" :class="[`supplier-type-${supplier.Value.VendorType}`]">{{ supplier.Value.VendorType }} Supplier</span>
            </div>  
            <span v-if='supplier && supplier.Value.Currencies'>
              Currencies accepted: {{ supplier.Value.Currencies }}
            </span>		
          </div>
           <div class="clear"></div>
        </div>
        <div slot='footer'></div>
      </ed-card>
    </div>
    <div class="clear"></div>
	<ed-notice v-if="supplierDifferentCurrency" type="warn" icon="fas fa-exclamation-triangle" class="v-align-center">
	  This supplier is not set up to accept payments in this currency.
	</ed-notice>
  </div>
  <!-- </ed-form> -->
</template>

<script>
import he from 'he'
import { Eved, EventBus } from '@/event-bus'

const statuses = {
  'EvedPay': 'evedpay',
  'EvedPay+': 'evedpay',
  'Non-EvedPay': 'not-evedpay'
}

export default {
  props: {
    model: Object,
    hasOnlyP2PPrograms: Boolean,
    isEoadmin: Boolean
  },

  data () {
    return {
      supplier: null,
      suppliers: [],
      bankAccount: '',
      currencyCode: '',
      originalSuppliers: [],

      displayEvedPayStatus: false,
      displayBankAccount: false,
      evedPayStatus: '',

      supplierDifferentCurrency: false,

      disableSupplier: function disableSupplier(supplier) {
        let disableSupp = supplier !== null || this.hasOnlyP2PPrograms
        EventBus.$emit('disableSupplier', disableSupp)
        return disableSupp
      },

      label: status => statuses[status] || 'default-status'
    }
  },

  created() {
    EventBus.$off(Eved.I2P.ADDED_NEW_SUPPLIER)
    EventBus.$on(Eved.I2P.ADDED_NEW_SUPPLIER, this.onAddedNewSupplier)

    EventBus.$off(Eved.I2P.REMOVE_SUPPLIER)
    EventBus.$on(Eved.I2P.REMOVE_SUPPLIER, this.removeSupplier)

    EventBus.$off(Eved.I2P.CURRENCY_SELECTED)
    EventBus.$on(Eved.I2P.CURRENCY_SELECTED, this.onUpdateCurrency)

    EventBus.$emit('checkEoNumber', this.model.Supplier.SupplierVCI)

    this.he = he
  },

  activated() {
    this.$nextTick(() => {
      this.updateEvedPayStatus()
      this.fetchBankAccount(this.model.Supplier.SupplierVCI, this.model.CurrencyCode)
    })
  },

  computed: {
    isP2PInvoice() {
      return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1
    },
    supplierComboPlaceholder() {
      return this.isP2PInvoice || this.hasOnlyP2PPrograms
        ? 'Please select PO first'
        : 'Start typing to search for your supplier'
    }
  },

  methods: {
    updateEvedPayStatus() {
      this.displayEvedPayStatus = false
      this.evedPayStatus = ''

      if (this.model.Supplier) {
        this.api.forms.post(
          this.api.$.invoice.i2p.supplierEvedPayStatus,
          {
            supplierId: this.model.SupplierId || 0,
            nonEvedEmail: this.model.Supplier.EmailAddress
          }
          ).then(r => {
            if (r && r.data && r.data.Data) {
              this.evedPayStatus = r.data.Data
              if (this.evedPayStatus) {
                this.displayEvedPayStatus = true
                if (this.evedPayStatus !== 'EvedPay' && this.evedPayStatus !== 'EvedPay+') {
                  this.supplierDifferentCurrency = false
                }
              }
            }
          }
          )
      }
    },

    //
    fetchSuppliersOnOpen() {
      this.suppliers.length || this.api.forms.post(this.api.$.invoice.suppliers, {
        q: '',
        invoiceId: this.model.PaymentInvoiceId
      })
        .then(r => {
          if (r && r.data && r.data.Data) {
            this.suppliers = JSON.parse(r.data.Data)
            this.originalSuppliers = JSON.parse(r.data.Data)
          }
        })
        .catch(e => console.warn(e))
      //
    },

    async fetchBankAccount(supplierEoNumber, currency) {
      if (!this.isEoadmin || supplierEoNumber === 0) {
        return
      }
      this.displayBankAccount = false
      this.bankAccount = ''
      let results = await this.api.post(this.api.$.invoice.suppliersBankAccount, {
        supplierEoNumber: supplierEoNumber,
        currency: currency
      })
      if (results && results.data) {
        this.bankAccount = results.data.Data
        this.currencyCode = currency
        this.displayBankAccount = !!this.bankAccount
      }
    },

    async fetchSuppliers(query) {
      let results = await this.api.forms.post(this.api.$.invoice.suppliers, {
        q: query || '',
        invoiceId: this.model.PaymentInvoiceId
      })

      if (results && results.data && results.data.Data) {
        this.suppliers = JSON.parse(results.data.Data)
      }
    },

    restoreSuppliers() {
      this.suppliers = utils.copy(this.originalSuppliers)
    },

    removeSupplier() {
      this.supplier = null
      this.supplierDifferentCurrency = false
      this.$emit('supplierRemoved', null)
      this.model.Errors.SupplierMissing = false
    },

    selectedSupplier(e) {
      this.model.SupplierId = e.Value.VendorId
      this.model.SupplierVci = e.Value.VendorVCI
      this.model.SupplierName = e.Value.SupplierName
      this.model.SupplierUserId = e.Value.ContactVendorUserId
      this.model.DiscountPaymentTermID = e.Value.DiscountPaymentTermId
      this.model.DiscountName = e.Value.DiscountName
      this.model.DiscountDisplayName = e.Value.DiscountDisplayName
      this.model.DaysNo = e.Value.DiscountDaysNo

      this.model.Supplier.VendorID = e.Value.VendorId
      this.model.Supplier.VendorUserID = e.Value.ContactVendorUserId
      this.model.Supplier.SupplierName = e.Value.CompanyName
      this.model.Supplier.SupplierContactName = e.Value.SupplierName
      this.model.Supplier.SupplierVCI = e.Value.Vci
      this.model.Supplier.SupplierZIP = e.Value.SupplierZIP
      this.model.Supplier.EmailAddress = e.Value.SupplierEmail
      this.model.Supplier.SupplierPhone = e.Value.SupplierPhone
      this.model.Supplier.VendorType = e.Value.VendorType
      this.model.Supplier.HasDefaultImmediatePayment = e.Value.HasDefaultImmediatePayment
      this.model.Supplier.WithholdingTaxPercent = e.Value.WithholdingTaxPercent
      this.model.Supplier.Currencies = e.Value.Currencies
      this.model.Supplier.SupplierAddress1 = e.Value.Address
      this.model.Supplier.SupplierAddress2 = e.Value.Address2
      this.model.Supplier.SupplierCity = e.Value.City
      this.model.Supplier.CountryName = e.Value.CountryName
      this.model.Supplier.SupplierRegion = e.Value.Region
      this.model.Supplier.SupplierState = e.Value.State

      this.model.Errors.SupplierMissing = false

      this.updateEvedPayStatus()

      if (this.model.CurrencyCode) {
        if (this.model.Supplier.VendorID > 0 && this.model.Supplier.Currencies && this.model.Supplier.Currencies.indexOf(this.model.CurrencyCode) === -1) {
          this.supplierDifferentCurrency = true
        } else {
          this.supplierDifferentCurrency = false
        }
      }

      this.$emit('supplierSelected', this.getSupplierSelectedModel(this.model, e.Value.Vci))
      EventBus.$emit('checkEoNumber', this.model.Supplier.SupplierVCI)
      this.fetchBankAccount(e.Value.Vci, this.model.CurrencyCode)
    },

    onUpdateCurrency(e) {
      this.currencyCode = e.data.code
      if (this.supplier && this.supplier.Value && this.supplier.Value.Vci) {
        this.fetchBankAccount(this.supplier.Value.Vci, this.currencyCode)
      }
      if (this.supplier && this.supplier.Value.VendorId > 0 && (this.evedPayStatus === 'EvedPay' || this.evedPayStatus === 'EvedPay+') && this.supplier.Value.Currencies.indexOf(e.data.code) === -1) {
        this.supplierDifferentCurrency = true
      } else {
        this.supplierDifferentCurrency = false
      }
    },

    onAddedNewSupplier(e) {
      var suppInfo = e.data
      var supplierInfoVM = suppInfo.SupplierInfoVM
      var cardInfo = suppInfo.CardInfo
      var logo = null
      if (cardInfo.logoPath && cardInfo.Logo) {
        logo = cardInfo.logoPath + cardInfo.Logo
      } else {
        logo = cardInfo.defaultImg
      }

      var newSupplier = {
        Key: suppInfo.VendorId,
        Value: {
          CompanyName: supplierInfoVM.SupplierName,
          ContactVendorUserId: suppInfo.VendorUserID,

          DefaultEmailImage: cardInfo.defaultEmailImg,
          DefaultImage: cardInfo.defaultImg,
          DefaultPhoneImage: cardInfo.defaultPhoneImg,
          Logo: logo,

          MyVendorTempEONumber: 0,
          NonEvedTempEoNumber: 0,

          SupplierEmail: supplierInfoVM.EmailAddress,
          SupplierName: supplierInfoVM.SupplierContactName,
          SupplierPhone: supplierInfoVM.SupplierPhone,
          VatGstId: supplierInfoVM.VatGstId,

          SupplierAddress1: supplierInfoVM.SupplierAddress1,
          SupplierAddress2: supplierInfoVM.SupplierAddress2,
          SupplierCity: supplierInfoVM.SupplierCity || this.model.Supplier.SupplierCity,
          City: supplierInfoVM.SupplierCity || this.model.Supplier.SupplierCity,
          State: supplierInfoVM.SupplierState,
          SupplierRegion: supplierInfoVM.SupplierRegion,
          SupplierZIP: supplierInfoVM.SupplierZIP,
          CountryName: supplierInfoVM.SupplierCountryName || this.model.Supplier.CountryName,
          VendorType: supplierInfoVM.VendorType,
          HasDefaultImmediatePayment: supplierInfoVM.HasDefaultImmediatePayment,
          Currencies: supplierInfoVM.Currencies,

          Vci: suppInfo.VendorVCI,
          VendorId: suppInfo.VendorId
        }
      }

      this.supplier = newSupplier

      this.model.SupplierId = suppInfo.VendorId
      this.model.SupplierName = supplierInfoVM.SupplierName
      this.model.SupplierUserId = suppInfo.VendorUserID
      this.model.DiscountPaymentTermID = supplierInfoVM.DiscountPaymentTermID
      this.model.DiscountName = supplierInfoVM.DiscountName
      this.model.DiscountDisplayName = supplierInfoVM.DiscountDisplayName
      this.model.DaysNo = supplierInfoVM.DiscountDaysNo

      // Supplier model
      this.model.Supplier = {
        ...this.model.Supplier,
        ...supplierInfoVM
      }
      this.model.Errors.SupplierMissing = false

      this.updateEvedPayStatus()

      if (suppInfo.VendorId > 0 && suppInfo.InvoiceCurrencyCode && supplierInfoVM.Currencies && supplierInfoVM.Currencies.indexOf(suppInfo.InvoiceCurrencyCode) === -1) {
        this.supplierDifferentCurrency = true
      } else {
        this.supplierDifferentCurrency = false
      }

      this.$emit('supplierSelected', this.getSupplierSelectedModel(this.model, suppInfo.VendorVCI, suppInfo.IsInitSupplier))
      this.fetchBankAccount(this.model.Supplier.SupplierVCI, this.model.CurrencyCode)
    },

    getSupplierSelectedModel(supplierInfoVM, vci, isInitSupplier) {
      return {
        SupplierInfoVM: supplierInfoVM,
        Vci: vci,
        IsInitSupplier: isInitSupplier
      }
    },

    getLabel(option) {
      return option.Value.CompanyName + (option.Value.Vci ? '(' + option.Value.Vci + ')' : '')
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.combo-txt {
  width: 36%;
}

.address-wrap {
  white-space: normal;
}

.no-wrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: calc(100% - 65px);
}

// List entry
.option {
  &-combo-img {
    width: 48px;
    margin: 5px 10px 5px 2px;
    display: block;
    float: left;
  }
  &-bold {
    display: inline-block;
    width: 85%;
    max-width: 87%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }
  &-em {
    font-weight: $font-weight-bold;
    float: right;
    @include theme {
    color: v(primary-05);
    }
  }
  &-strong {
    display: inline-block;
    width: 85%;
    max-width: 87%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @include theme {
    color: v(primary-05);
    }
  }
}

// Card entry
.supplier {
  &-txt {
    width: 60%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  &-strong {
    max-width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @include theme {
    color: v(primary-05);
    }
  }
  &-em {
    font-size: 15px;
    font-weight: $font-weight-bold;

    margin-top: 3px;
    display: inline-block;
    position: absolute;
    right: 40px;

    @include theme {
    color: v(primary-05);
    }
  }
  &-details[class] {
    width: 100%;
    height: auto;

    .status-label {
      margin-top: 10px;
    }
  }
  &-img {
    height: 90px;
    width: 90px;
    margin: 5px 10px 5px 2px;
    display: block;
    float: left;
  }
  &-evedpay{
    @include theme {
    color: v(canvas);
    background-color: #009FCC;
    border-color: #009FCC;
    }
  }
  &-not-evedpay{
    @include theme {
    color: v(canvas);
    background-color: #e02630;
    border-color: #e02630;
    }
  } 
  &-type-preferred {
    @include theme {
    color: v(canvas);
    background-color: #009FCC;
    border-color: #009FCC;
    }
  }
  &-type-approved {
    @include theme {
    color: v(canvas);
    background-color: #75A628;
    border-color: #75A628;
    }
  }
  &-type-pending {
    color: #666666;
    background-color: #FFFFFF;
    border-color: #666666;
  }
  &-default-status {
    color: #666666;
    background-color: #FFFFFF;
    border-color: #666666;
  }
}

.label {
  text-transform: capitalize;
}
.supplier-txt .label {
  height: 20px;
}

.bank-account {
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 2px;
  background: #CDE2E8;
}

.contact-icon {
  @include theme {
    color: v(tertiary-01);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/Supplier.vue